import React from 'react';

/**
 * Default JSX label shown next to the T&Cs acceptance checkbox in submit dialogs.
 * Renders a link that opens the latest uploaded PDF in a new tab via /api/terms/file.
 */
export const TermsAcceptanceLabel = () => {
  const backend = process.env.REACT_APP_BACKEND_URL;
  return (
    <>
      I have read and agree to the{' '}
      <a
        href={`${backend}/api/terms/file`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="terms-link-inline"
        className="text-gold underline hover:text-gold-hover"
      >
        Terms of Trade
      </a>
      .
    </>
  );
};

export default TermsAcceptanceLabel;
